var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  First & Last Mile Settings")]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Setting Variables")]), _vm._v(" "), _c('th', [_vm._v("Values")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Trip Shipment Scan")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.hubaccessObjArray,
      "name": "hubid",
      "id": "hubid",
      "placeholder": "Select Hub",
      "label": "hubname",
      "track-by": "hubname"
    },
    on: {
      "select": _vm.onchange
    },
    model: {
      value: (_vm.hubid),
      callback: function($$v) {
        _vm.hubid = $$v
      },
      expression: "hubid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanType),
      expression: "scanType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "AWB",
      "value": "AWB",
      "name": "scanType"
    },
    domProps: {
      "checked": _vm._q(_vm.scanType, "AWB")
    },
    on: {
      "__c": function($event) {
        _vm.scanType = "AWB"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "AWB"
    }
  }, [_vm._v("AWB ")]), _vm._v("     \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scanType),
      expression: "scanType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "MPS",
      "value": "MPS",
      "name": "scanType"
    },
    domProps: {
      "checked": _vm._q(_vm.scanType, "MPS")
    },
    on: {
      "__c": function($event) {
        _vm.scanType = "MPS"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "MPS"
    }
  }, [_vm._v("MPS")]), _vm._v("     \n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'TripShipmentScan')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Trip Pallet Scan")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.hubaccessObjArray,
      "name": "hubid",
      "id": "hubid",
      "placeholder": "Select Hub",
      "label": "hubname",
      "track-by": "hubname"
    },
    on: {
      "select": _vm.onchange
    },
    model: {
      value: (_vm.hubid),
      callback: function($$v) {
        _vm.hubid = $$v
      },
      expression: "hubid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cft')),
      expression: "errors.has('cft')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cft')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPalletScan),
      expression: "isPalletScan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "AWB",
      "value": "1",
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.isPalletScan, "1")
    },
    on: {
      "__c": function($event) {
        _vm.isPalletScan = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "AWB"
    }
  }, [_vm._v("YES ")]), _vm._v("     \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPalletScan),
      expression: "isPalletScan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "MPS",
      "value": "0",
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.isPalletScan, "0")
    },
    on: {
      "__c": function($event) {
        _vm.isPalletScan = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "MPS"
    }
  }, [_vm._v("NO")]), _vm._v("     \n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'TripPalletScan')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Enable DWS Scan")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.hubaccessObjArray,
      "name": "dwshubname",
      "id": "dwshubid",
      "placeholder": "Select Hub",
      "label": "hubname",
      "track-by": "hubname"
    },
    on: {
      "select": _vm.onchange
    },
    model: {
      value: (_vm.hubid),
      callback: function($$v) {
        _vm.hubid = $$v
      },
      expression: "hubid"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cft')),
      expression: "errors.has('cft')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('cft')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDwsScanEnable),
      expression: "isDwsScanEnable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "dwsscanenable",
      "name": "dwsscanenable",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.isDwsScanEnable, "1")
    },
    on: {
      "__c": function($event) {
        _vm.isDwsScanEnable = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("YES ")]), _vm._v("     \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isDwsScanEnable),
      expression: "isDwsScanEnable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "dwsscannotenable",
      "name": "dwsnotscanenable",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.isDwsScanEnable, "0")
    },
    on: {
      "__c": function($event) {
        _vm.isDwsScanEnable = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("NO")]), _vm._v("     \n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'EnableDWSScan')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("FTC Cash Collect Limit")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ftccashlimit),
      expression: "ftccashlimit"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "ftccashlimit",
      "id": "ftccashlimit",
      "placeholder": "Enter FTC Cash Collect Limit"
    },
    domProps: {
      "value": (_vm.ftccashlimit)
    },
    on: {
      "keypress": function($event) {
        _vm.isIntegerOnly($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftccashlimit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ftccashlimit')),
      expression: "errors.has('ftccashlimit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FTCAMterr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'FTCCashCollect')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pickup Request Cut-off Time "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }, [_vm._v("24 hrs time format.\n                  (HH:MM)")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prcutofftime),
      expression: "prcutofftime"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|verify_prcutoff'),
      expression: "'required|verify_prcutoff'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('prcutofftime')
    },
    attrs: {
      "type": "text",
      "name": "prcutofftime",
      "id": "prcutofftime",
      "placeholder": "hh:mm",
      "maxlength": "5"
    },
    domProps: {
      "value": (_vm.prcutofftime)
    },
    on: {
      "keyup": _vm.prcutOffcheck,
      "select": _vm.selectedPR,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prcutofftime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('prcutofftime')),
      expression: "errors.has('prcutofftime')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('prcutofftime')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'PRQCutoff')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pickup Request\n                "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "11px",
      "color": "red"
    }
  }, [_vm._v("(Visibility of checkbox to view pickup request of all\n                  hubs)")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.RolesList,
      "name": "RolesList",
      "id": "RolesList",
      "placeholder": "Select the user role",
      "label": "rolename",
      "track-by": "rolename",
      "multiple": true,
      "scroll": true,
      "hide-selected": true
    },
    model: {
      value: (_vm.roleId),
      callback: function($$v) {
        _vm.roleId = $$v
      },
      expression: "roleId"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'PickupRequest')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Auto Allocation Cut-off Weight "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }, [_vm._v("Ex: 120% will be 120.")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autocutoffweight),
      expression: "autocutoffweight"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "autocutoffweight",
      "id": "autocutoffweight",
      "placeholder": "Cut-off Weight"
    },
    domProps: {
      "value": (_vm.autocutoffweight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autocutoffweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('autocutoffweight')),
      expression: "errors.has('autocutoffweight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("{{}}")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'AutoAllocWeight')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Auto Allocation AWB Fetch Limit "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  })]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.autofetchdatalimit),
      expression: "autofetchdatalimit"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "autofetchdatalimit",
      "id": "autofetchdatalimit",
      "placeholder": "AWB Fetch Limit"
    },
    domProps: {
      "value": (_vm.autofetchdatalimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.autofetchdatalimit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('autofetchdatalimit')),
      expression: "errors.has('autofetchdatalimit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("{{}}")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'AutoAllocLimit')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pickup Request Weight Threshold "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }, [_vm._v("Weight in KG")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prwtthreshold),
      expression: "prwtthreshold"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('prwtthreshold')
    },
    attrs: {
      "type": "number",
      "name": "Pickup Request Weight Threshold",
      "id": "prwtthreshold",
      "placeholder": "Pickup Request Weight Threshold"
    },
    domProps: {
      "value": (_vm.prwtthreshold)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.prwtthreshold = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Pickup Request Weight Threshold')),
      expression: "errors.has('Pickup Request Weight Threshold')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Pickup Request Weight Threshold')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'PRQWeightThreshold')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Pending Pod Pendancy Days")]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pendingpodpendencydays),
      expression: "pendingpodpendencydays"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('pendingpodpendencydays')
    },
    attrs: {
      "type": "number",
      "name": "pendingpodpendencydays",
      "id": "pendingpodpendencydays",
      "placeholder": "Pendency Day's to Restrict SR Trip"
    },
    domProps: {
      "value": (_vm.pendingpodpendencydays)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pendingpodpendencydays = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('pendingpodpendencydays')),
      expression: "errors.has('pendingpodpendencydays')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.pendingPoderr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'PODPENDENCYDAYS')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Enable Global Delivery "), _c('br')]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globaldeliveryflag),
      expression: "globaldeliveryflag"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "globaldeliveryyes",
      "value": "1",
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.globaldeliveryflag, "1")
    },
    on: {
      "__c": function($event) {
        _vm.globaldeliveryflag = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "globaldeliveryyes"
    }
  }, [_vm._v("YES ")]), _vm._v("     \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globaldeliveryflag),
      expression: "globaldeliveryflag"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "globaldeliveryno",
      "value": "0",
      "name": "shipmentType"
    },
    domProps: {
      "checked": _vm._q(_vm.globaldeliveryflag, "0")
    },
    on: {
      "__c": function($event) {
        _vm.globaldeliveryflag = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "globaldeliveryno"
    }
  }, [_vm._v("NO")]), _vm._v("     \n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'globaldel')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Trackon Email Recepient "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }, [_vm._v("Enter email ids comma\n                  separated")])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "options": _vm.hubaccessObjArray,
      "name": "emailrecipienthubid",
      "id": "emailrecipienthubid",
      "placeholder": "Select Hub",
      "label": "hubname",
      "track-by": "hubname"
    },
    on: {
      "select": _vm.onchange
    },
    model: {
      value: (_vm.hubid),
      callback: function($$v) {
        _vm.hubid = $$v
      },
      expression: "hubid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.emailrecipient),
      expression: "emailrecipient"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "emailrecipient",
      "id": "emailrecipient",
      "placeholder": "Enter Email ids"
    },
    domProps: {
      "value": (_vm.emailrecipient)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailrecipient = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('emailrecipient')),
      expression: "errors.has('emailrecipient')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.FTCAMterr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveEmailData()
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GREEN TAX PINCODES "), _c('br'), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "11px"
    }
  }, [_vm._v("Enter pincodes comma separated")])]), _vm._v(" "), _c('td', [_c('form', {
    attrs: {
      "data-vv-scope": "greentaxpincodeform"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.GreenTaxPincodes),
      expression: "GreenTaxPincodes"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('verify_pincode'),
      expression: "'verify_pincode'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('greentaxpincodeform.GreenTaxPincodes')
    },
    attrs: {
      "rows": 3,
      "id": "GreenTaxPincodes",
      "name": "GreenTaxPincodes",
      "placeholder": "Enter Green tax pincodes"
    },
    domProps: {
      "value": (_vm.GreenTaxPincodes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.GreenTaxPincodes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "pincodeHelpBlock"
    }
  }, [_vm._v("Note: Use Comma (,) for Multiple\n                        Pincodes. Without Space.")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('greentaxpincodeform.GreenTaxPincodes')),
      expression: "errors.has('greentaxpincodeform.GreenTaxPincodes')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('greentaxpincodeform.GreenTaxPincodes')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveGreenTaxPincodeData()
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Enable Global Encryption "), _c('br')]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.encryptflag),
      expression: "encryptflag"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "globalencryptionyes",
      "value": "1",
      "name": "encryptflag"
    },
    domProps: {
      "checked": _vm._q(_vm.encryptflag, "1")
    },
    on: {
      "__c": function($event) {
        _vm.encryptflag = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "globalencryptionyes"
    }
  }, [_vm._v("YES ")]), _vm._v("     \n                      "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.encryptflag),
      expression: "encryptflag"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    attrs: {
      "type": "radio",
      "id": "globalencryptionno",
      "value": "0",
      "name": "encryptflag"
    },
    domProps: {
      "checked": _vm._q(_vm.encryptflag, "0")
    },
    on: {
      "__c": function($event) {
        _vm.encryptflag = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "for": "globalencryptionno"
    }
  }, [_vm._v("NO")]), _vm._v("     \n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveAdminSettings('flm', 'globalencryption')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("FTC Unsettled Cash Limit ")]), _vm._v(" "), _c('td', [_c('form', {
    attrs: {
      "data-vv-scope": "ftcform"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('verify_floatvalue'),
      expression: "'verify_floatvalue'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ftcsettlementlimit),
      expression: "ftcsettlementlimit"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "ftcsettlementlimit",
      "id": "ftcsettlementlimit",
      "placeholder": "Enter FTC Unsettled Cash Limit"
    },
    domProps: {
      "value": (_vm.ftcsettlementlimit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftcsettlementlimit = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ftcform.ftcsettlementlimit')),
      expression: "errors.has('ftcform.ftcsettlementlimit')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ftcform.ftcsettlementlimit')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveFtcConfig('ftcsettlementlimit')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("FTC TDS Percentage")]), _vm._v(" "), _c('td', [_c('form', {
    attrs: {
      "data-vv-scope": "ftcform"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('verify_floatvalue'),
      expression: "'verify_floatvalue'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ftctdsper),
      expression: "ftctdsper"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "ftctdsper",
      "id": "ftctdsper",
      "min": 0.01,
      "max": 100,
      "placeholder": "Enter FTC TDS Percentage"
    },
    domProps: {
      "value": (_vm.ftctdsper)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ftctdsper = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ftcform.ftctdsper')),
      expression: "errors.has('ftcform.ftctdsper')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ftcform.ftctdsper')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rows"
  }, [_c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveFtcConfig('ftctdsper')
      }
    }
  }, [_vm._v("Save  "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02b25638","hasScoped":true}!./src/modules/adminsettings/views/configuration/FLMConfiguration/flmconfiguration.component.html
// module id = 2014
// module chunks = 3